module.exports = __webpack_public_path__ + "img/pickdown.befb6469.svg";